<template>
  <div>
    <classification ref="classification"></classification>
    <workorder ref="workorder"></workorder>
    <faultReport ref="faultReport"></faultReport>
    <fixplan ref="fixplan"></fixplan>
    <flowmap ref="flowmap"></flowmap>
  </div>
</template>

<script>
import classification from "@/page/zhonglv/classification.vue";//设备分类
import workorder from "@/page/zhonglv/workorder.vue";//工单
import faultReport from "@/page/zhonglv/faultReport.vue";//故障提报单
import fixplan from "@/page/zhonglv/fixplan.vue";//检修计划
import flowmap from "./flowmap.vue";//根据流程节点控制界面只读必填
export default {
  name: 'zhonglv',
  components: {
    classification,
    workorder,
    faultReport,
    fixplan,
    flowmap
  },
  data() {
    return {
      basic_url: Config.dev_url,
      //item 当前点击按钮信息
      //this.$store.state.detailInfo  当前数据信息
      //this.$store.state.childrensInfo  子表数据
    }
  },
  methods: {
    //主表详情按钮
    detailTableButtons(item) {
      console.log(item, "客户化处理完成了");
      if (item != undefined && item.eventmethod != undefined) {
        this[item.eventmethod](item);
      }
    },
    //主表列表按钮
    listTableButtons(item, listData) {
      if (item != undefined && item.eventmethod != undefined) {
        this[item.eventmethod](item, listData);
      }
    },
    //子表按钮
    childTableButtons(item, childSelectData, buttonlists, currentChild) {
      console.log(item, childSelectData, "子表客户化处理完成了")
      if (!!item.options.isCustomizedprocessing) {
        this[item.options.customizedprocessingevent](item, childSelectData);
      }
    },
    //下拉框选中
    selectChange(item, val, data) {
      console.log(item, val, data, "下拉框客户化处理完成了")
      if (!!item.options.isCustomizedprocessing) {
        this[item.options.customizedprocessingevent](val, data);
      }
    },
    //开关按钮
    switchChange(item, val) {
      //item 当前开关的信息    val 当前值
      console.log(item, val, "switch客户化处理完成了")
      if (!!item.options.isCustomizedprocessing) {
        this[item.options.customizedprocessingevent](item, val);
      }
    },
    //弹出框按钮
    allInputButtons(item, selectData, childData) {
      console.log(item, selectData, "弹出框客户化处理完成了")
      if (!!item.options.isCustomizedprocessing) {
        this[item.options.customizedprocessingevent](item, selectData, childData);
      }
    },
    //弹出框清空的方法
    clearInputBtnData(item, data) {
      console.log(item, data, "清除弹出框客户化处理完成了")
      if (!!item.options.isCustomizedprocessing) {
        this[item.options.clearcustomizedprocessingevent](item, data);
      }
    },
    //子表批量选择按钮确定处理
    childBatchButtons(item, selectData) {
      console.log(item, selectData, "子表批量选择客户化处理完成了")
      if (!!item.options.isCustomizedprocessing) {
        this[item.options.customizedprocessingevent](item, selectData);
      }
    },
    //所有应用流程进入详情
    flowView(loadingObj) {
      this.$refs.flowmap.ishasFlow(loadingObj);
    },
    //选择设备分类带出技术参数
    classifyChange(item, selectData) {
      this.$refs.classification.classifyChange(item, selectData);
    },
    //清空设备分类操作
    clearClassify(item, data) {
      this.$refs.classification.clearClassify(item, data);
    },
    //工单选择缺陷提报
    selReportnum(item, selectData) {
      this.$refs.workorder.selReportnum(item, selectData);
    },
    //工单清空缺陷提报
    clearReportnum(item, data) {
      this.$refs.workorder.clearReportnum(item, data);
    },
    //工单选择检修计划
    seFixplan(item, selectData) {
      this.$refs.workorder.seFixplan(item, selectData);
    },
    //工单清空检修计划
    clearFixplan(item, data) {
      this.$refs.workorder.clearFixplan(item, data);
    },
    //选择设备带出位置描述
    chooseLocation(item, selectData) {
      this.$refs.workorder.chooseLocation(item, selectData);
    },
    //故障提报单事故级别下拉框
    levelChange(val, data) {
      this.$refs.faultReport.levelChange(val, data);
    },
    //故障提报选择设备带出位置描述
    chooseAsset(item, selectData) {
      this.$refs.faultReport.chooseAsset(item, selectData);
    },
    //检修计划子表汇总按钮
    fixSum(item, childSelectData) {
      this.$refs.fixplan.fixSum(item, childSelectData);
    }
  }
}
</script>

<style>
</style>
